import styled from 'styled-components'

import { premiumFontCss } from '@blade/ui-theme'
import { useTranslation } from '@root/shared/localization'

import { SupportIcon } from './support-icon'

import type { ClassNameProps } from '@root/shared/lib/react'

type SupportWelcomeHeaderProps = { online: boolean } & ClassNameProps

export const SupportWelcomeHeader: React.FC<SupportWelcomeHeaderProps> = ({
  online,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <Header className={className}>
      <SeparatorStart />
      <Headline>
        <SupportIcon online={online} />
        <Title>
          {t('support.welcome-title-welcome')} <br />
          {t('support.welcome-title-to')}
          <span>{t('support.welcome-brand')}</span>
        </Title>
      </Headline>
      <SeparatorEnd />
    </Header>
  )
}

const Header = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
`

const SeparatorStart = styled.div`
  width: 52px;
  height: 1px;
  opacity: 0.1;
  background: linear-gradient(90deg, transparent 0%, var(--background-12) 100%);
`

const SeparatorEnd = styled.div`
  width: 52px;
  height: 1px;
  opacity: 0.1;
  background: linear-gradient(
    270deg,
    transparent 0%,
    var(--background-12) 100%
  );
`

const Headline = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 12px;
`

const Title = styled.h2`
  color: var(--text-12);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  span {
    ${premiumFontCss}
  }
`
